module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "placeholderChart.2e601cdf.png";